export default "__VITE_ASSET__VWwheoQHW_e8UcRiND$XOg__"